import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  Storage,
  ref,
  deleteObject,
  uploadBytes,
  uploadString,
  uploadBytesResumable,
  percentage,
  getDownloadURL
} from '@angular/fire/storage';


@Injectable({
  providedIn: 'root'
})
export class ImageuploadService {

  constructor(
    private storage: Storage
  ) {
  }

  async upload(folder: string, name: string, file: File | null): Promise<string> {
    const ext = file!.name.split('.').pop();
    let url: any;
    const path = `${folder}/${name}.${ext}`; {
      if (file) {
        try {
          const storageRef = ref(this.storage, path);
          const task = uploadBytesResumable(storageRef, file);
          await task;
          url = await getDownloadURL(storageRef);
        } catch (e: any) {
          console.error(e);
        }
      } else {

      }
      return url
    }
  }

  async uploadFromBase64(folder: string, name: string, base64:string,): Promise<string> {
    //cut extension from datbase 64 IMPORTANT
    let extLastInd = base64.indexOf(";base64,");
    let extFirstInd = base64.indexOf("/");
    const ext = base64.substring(extFirstInd+1,extLastInd);
    


    // const ext = file!.name.split('.').pop();
    let url: any;
    const path = `${folder}/${name}.${ext}`; {
      if (base64) {
        try {
          const storageRef = ref(this.storage, path);
          const task = uploadString(storageRef, base64,'data_url');
          await task;
          url = await getDownloadURL(storageRef);
          
        } catch (e: any) {
          console.error(e);
        }
      } else {

      }
      return url
    }
  }


  async startUpload(path: any, file: any) {
    const basePath = `${path}/${new Date().getFullYear()}/${Date.now()}_${file.name}`;
    const storageRef = ref(this.storage, basePath);
    const uploadTask = uploadBytesResumable(storageRef, file);

    // Register three observers:
    // 1. 'state_changed' observer, called any time the state changes
    // 2. Error observer, called on failure
    // 3. Completion observer, called on successful completion
    uploadTask.on('state_changed',
      (snapshot) => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        // this.progress=progress;
        
        switch (snapshot.state) {
          case 'paused':
            
            break;
          case 'running':
            
            break;
        }
      },
      (error) => {
        
        // Handle unsuccessful uploads
      },
      () => {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          // this.imgObj.downloadURL=downloadURL;
          // this.imgObj.cdate=new Date().getTime();
          // this.uploadData.emit(this.imgObj);
          return downloadURL;
        });
      }
    );


  }
}
